import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Button, Alert } from "react-bootstrap";
import Validation from "../../hooks/Validation";
import Styles from "./LoginForm.module.css";
import { useDispatch, useSelector } from "react-redux";
import { resetError } from "../../store/reducerSlice/admin";
import { adminLogin } from "../../store/actions/adminAction";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import ApiResponsePopup from "../common/modal/ApiResponsePopup";
import provider from '../../assets/images/product.png'

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [password, setPassword] = useState("");
  const [eyes, setEyes] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);

  const [privacyChecked, setPrivacyChecked] = useState(true);
  const [termsChecked, setTermsChecked] = useState(true);

  const handlePrivacyChange = (event) => {
    setPrivacyChecked(event.target.checked);
  };

  const handleTermsChange = (event) => {
    setTermsChecked(event.target.checked);
  };
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    Validation({
      clientEmail,
      password,
    });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    isAdminLoggedIn,
    adminDetail,
    error: apiError,
  } = useSelector((state) => state.admin);

  useEffect(() => {
    if (isAdminLoggedIn && adminDetail) {
      console.log("adminDetail", adminDetail);
      navigate("/");
    }
    return () => {
      dispatch(resetError());
    };
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();

    // Check if the checkboxes are checked
    if (!privacyChecked || !termsChecked) {
      alert("Please accept the Policy-Notice and Terms & Conditions.");
    } else {
      checkValidator();
      setIsActionCalled(true);
    }
  };

  useEffect(() => {
    if (!isError() && error !== null && isActionCalled) {
      dispatch(adminLogin({ clientEmail, password })).then((payload) => {
        if (payload?.payload) {
          if (!payload?.payload?.success) {
            setIsShow(true);
            return;
          }

          const responseData = payload?.payload?.data || {};
          const token = responseData?.token;
          const mfaRequired = !!responseData?.mfaRequired;

          if (mfaRequired) {
            sessionStorage.setItem(
              "pendingMfaLogin",
              JSON.stringify({ clientEmail })
            );
            sessionStorage.setItem("mfaFromLogin", "1");
            navigate("/login-mfa");
          } else if (token) {
            sessionStorage.removeItem("pendingMfaLogin");
            navigate("/");
          } else {
            setIsShow(true);
          }
        }
      });
      setIsActionCalled(false);
    } else {
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  return (
    <Form
      onSubmit={(e) => submitHandler(e)}
      className="loginFormSection"
      noValidate
    >
      <h1 className="loginTitle">Login</h1>
      <Form.Group className="mb-4 mt-4" controlId="formBasicEmail">
        <Form.Label>
          Email <span className="required">*</span>
        </Form.Label>
        <Form.Control
          className="py-2 input-form"
          type="email"
          name="email"
          placeholder="Enter email"
          onChange={(e) => {
            setClientEmail(e.target.value);
            resetValidator(e.target.name);
          }}
          isInvalid={error?.clientEmail}
        />
        <Form.Control.Feedback type="invalid">
          {error?.clientEmail}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-2 rowField mt-3" controlId="formBasicPassword">
        <Form.Label>
          Password <span className="required">*</span>
        </Form.Label>
        <Form.Control
          type={eyes ? "text" : "password"}
          name="password"
          placeholder="Enter Password"
          className="py-2"
          onChange={(e) => {
            setPassword(e.target.value);
            resetValidator(e.target.name);
          }}
          isInvalid={error?.password}
        />
        <div className="eyeIcon" onClick={(e) => setEyes(!eyes)}>
          {eyes ? <Eye /> : <EyeSlash />}
        </div>
        <Form.Control.Feedback type="invalid">
          {error?.password}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group
        className="mb-3 align-right forgetLink"
        controlId="formBasicPassword"
      >
        <Link to="/forgot-password">Forgot Password?</Link>
      </Form.Group>
      <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check
          type="checkbox"
          checked={privacyChecked}
          onChange={handlePrivacyChange}
         
          label={
            <span>
              <a href="/privacy-notice" target="_blank">Privacy-Notice</a>
            </span>
          }
        />
        <Form.Check
          type="checkbox"
          checked={termsChecked}
          onChange={handleTermsChange}
         
          label={
            <span>
              <a href="/terms-and-conditions" target="_blank">Terms-and-Conditions</a>
            </span>
          }
        />
      </Form.Group>

      <Button
        className="btn-primary mt-2 border-0 mb-2"
        style={{
          fontSize: "14px",
          height: "48px",
          filter: "drop-shadow()",
          boxShadow: "1px 4px 8px 1px rgba(133, 93, 217, 0.5)",
        }}
        type="submit"
      >
        Login
      </Button>
      <Form.Group className="text-center ms-2 ">Powered by</Form.Group>
      <div className="text-center">
        <img style={{ width: "20%",  }} src={provider} alt="" />
      </div>
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordUpdated: isShow,
          title: "Login",
          errorRes: apiError?.message
            ? apiError?.message
            : "Something went wrong!!",
        }}
      />
    </Form>
  );
};

export default LoginForm;
